import {Nullish} from 'shared/web';

import {isCarvagoWorkspace} from '../../../utils/isCarvagoWorkspace';
import {parseInspectionReport} from './parseInspectionReport';

/**
 * The formatted `ca-report` comment is a Carvago-only feature; other workspaces keep the plain-text
 * comment even when it holds report HTML.
 */
export function getInspectionReport(comment: string | Nullish) {
  return isCarvagoWorkspace() ? parseInspectionReport(comment) : null;
}
